module.exports = __webpack_public_path__ + "static/media/10.37213411.png";